import React from "react";

import clsx from "clsx";
import { components } from "react-select";
import CreatableSelect from "react-select/creatable";

interface Option {
  label: string;
  value: string;
}

interface Props {
  options: Option[];
  value: Option;
  isDisabled?: boolean;
  onChange(value: any): void;
}

export const BreakdownSelector = ({
  options,
  value,
  isDisabled,
  onChange,
}: Props) => (
  <CreatableSelect
    components={{
      DropdownIndicator: (props) => (
        <components.DropdownIndicator {...props}>
          <i
            className={clsx(
              "fa-regular fa-sharp fa-chevron-down text-[0.65rem] px-2",
              {
                "text-interstellar+2": !props.isDisabled,
                "text-gray+1": props.isDisabled,
              },
            )}
          />
        </components.DropdownIndicator>
      ),
      IndicatorSeparator: null,
    }}
    classNames={{
      container: () => "h-[37px]",
      control: () => "border-0 bg-[transparent] min-h-[37px]",
      menu: () => "z-30",
      option: (props) => {
        if (props.isSelected) {
          return `font-bold text-interstellar ${
            props.isFocused ? "bg-cosmic-4" : "bg-transparent"
          }`;
        }

        if (props.isFocused) {
          return "bg-cosmic-4";
        }

        return "";
      },
    }}
    isDisabled={isDisabled}
    value={value}
    onChange={onChange}
    options={options}
    placeholder="Select..."
  />
);
